export const TicketType = Object.freeze({
  Text: '文本',
  Number: '数字',
  Select: '下拉框',
  Date: '日期',
  Time: '时间',
  DateTime: '日期+时间',
  Swich: '开关',
  Mul: '多选项',
  Address: '地址选择器',
  Image: '图片',
  Position: '定位',
  Code: '扫码',
  Textarea: '多行文本',
  Info: '说明文本',
  File: '附件',
  Checkbox: '多选',
  Radio: '单选',
})
